import styled from "styled-components";

export const AccordionSectionHeading = styled.h2`
  margin-top: 0;
  margin-bottom: 0;
`;

AccordionSectionHeading.displayName = "AccordionSectionHeading";
